export const ALERT_BROADCAST_CHANNEL_TIMEOUT = 1000;
export const ALERT_MANAGER_EVENT_CLEAR_BANNER = 'clearBanner';
export const ALERT_MANAGER_EVENT_CLEAR_MODAL = 'clearModal';
export const ALERT_MANAGER_EVENT_CLEAR_TOOLTIP = 'clearTooltip';
export const ALERT_MANAGER_EVENT_DISPLAY_MODAL = 'displayModal';
export const ALERT_MANAGER_EVENT_DISPLAY_MODAL_WITH_PROMISE = 'displayModalWithPromise';
export const ALERT_MANAGER_EVENT_DISPLAY_BANNER = 'displayBanner';
/**
 * @deprecated Toasts now render in the browser top layer; the local toast
 * variant is no longer required. This event will be removed in a future
 * release. Use {@link ALERT_MANAGER_EVENT_DISPLAY_TOAST} instead.
 */
export const ALERT_MANAGER_EVENT_DISPLAY_LOCAL_TOAST = 'displayLocalToast';
export const ALERT_MANAGER_EVENT_DISPLAY_TOAST = 'displayToast';
export const ALERT_MANAGER_EVENT_DISPLAY_TOOLTIP = 'displayTooltip';
export const ALERT_MANAGER_EVENT_UPDATE_TOOLTIP = 'updateTooltip';
export const ALERT_MANAGER_EVENTS = Object.freeze([
  ALERT_MANAGER_EVENT_CLEAR_BANNER,
  ALERT_MANAGER_EVENT_CLEAR_MODAL,
  ALERT_MANAGER_EVENT_CLEAR_TOOLTIP,
  ALERT_MANAGER_EVENT_DISPLAY_MODAL,
  ALERT_MANAGER_EVENT_DISPLAY_MODAL_WITH_PROMISE,
  ALERT_MANAGER_EVENT_DISPLAY_BANNER,
  ALERT_MANAGER_EVENT_DISPLAY_LOCAL_TOAST,
  ALERT_MANAGER_EVENT_DISPLAY_TOAST,
  ALERT_MANAGER_EVENT_DISPLAY_TOOLTIP,
  ALERT_MANAGER_EVENT_UPDATE_TOOLTIP,
]);
export const ALERT_MANAGER_EVENT_TYPE_BANNER = 'banner';
/**
 * @deprecated Toasts now render in the browser top layer; the local toast
 * variant is no longer required. This event type will be removed in a future
 * release. Use {@link ALERT_MANAGER_EVENT_TYPE_TOAST} instead.
 */
export const ALERT_MANAGER_EVENT_TYPE_LOCAL_TOAST = 'localToast';
export const ALERT_MANAGER_EVENT_TYPE_MODAL = 'modal';
export const ALERT_MANAGER_EVENT_TYPE_MODAL_WITH_PROMISE = 'modalWithPromise';
export const ALERT_MANAGER_EVENT_TYPE_TOAST = 'toast';
export const ALERT_MANAGER_EVENT_TYPE_TOOLTIP = 'tooltip';
export const INSTANCE_DEFAULT = 'global';

export default {
  ALERT_BROADCAST_CHANNEL_TIMEOUT,
  ALERT_MANAGER_EVENT_CLEAR_BANNER,
  ALERT_MANAGER_EVENT_CLEAR_MODAL,
  ALERT_MANAGER_EVENT_CLEAR_TOOLTIP,
  ALERT_MANAGER_EVENT_DISPLAY_MODAL,
  ALERT_MANAGER_EVENT_DISPLAY_MODAL_WITH_PROMISE,
  ALERT_MANAGER_EVENT_DISPLAY_BANNER,
  ALERT_MANAGER_EVENT_DISPLAY_LOCAL_TOAST,
  ALERT_MANAGER_EVENT_DISPLAY_TOAST,
  ALERT_MANAGER_EVENT_DISPLAY_TOOLTIP,
  ALERT_MANAGER_EVENT_UPDATE_TOOLTIP,
  ALERT_MANAGER_EVENTS,
  ALERT_MANAGER_EVENT_TYPE_BANNER,
  ALERT_MANAGER_EVENT_TYPE_LOCAL_TOAST,
  ALERT_MANAGER_EVENT_TYPE_MODAL,
  ALERT_MANAGER_EVENT_TYPE_MODAL_WITH_PROMISE,
  ALERT_MANAGER_EVENT_TYPE_TOAST,
  ALERT_MANAGER_EVENT_TYPE_TOOLTIP,
  INSTANCE_DEFAULT,
};
